import React from "react";
import { RadioButton } from "primereact/radiobutton";
import { Label, InputText, Dropdown } from "../../../components/Inputs";
import HtmlContentForm from "../../Static/components/content/HtmlContentForm";
import LinkForm from "./LinkForm";

const NewsArticleForm = React.forwardRef(function NewsArticleForm(
  { className = "", model, disabled },
  ref,
) {
  const [state, setState] = React.useState({
    title: model.title || "",
    subtitle: model.subtitle != null ? model.subtitle : "",
    isPrivate: model.isPrivate != null ? model.isPrivate : 1,
    body: model.body || "",
    category_id: model.category_id || 1,
    type_id: model.type_id || 1,
    error: {
      title: null,
      isPrivate: null,
      type_id: null,
    },
  });
  const bodyFormRef = React.useRef(null);

  const validate = () => {
    const { error, ...modelData } = state;
    // check if all values are set
    const newError = { ...error };
    let isValid = true;
    Object.keys(modelData).forEach((key) => {
      if (newError[key] !== undefined && modelData[key] === "") {
        newError[key] = true;
        isValid = false;
      }
    });
    // body
    const bodyModel = bodyFormRef.current.getModel();
    if (!bodyModel) {
      isValid = false;
    } else {
      modelData.body = bodyModel.body;
    }
    setState((prev) => ({ ...prev, error: newError }));
    if (!isValid) {
      return null;
    }
    if (model.id) {
      modelData.id = model.id;
    }
    return modelData;
  };
  const getModel = () => {
    const modelData = validate();
    if (modelData) {
      modelData.isPrivate = modelData.isPrivate === "0" ? 0 : 1;
    }
    return modelData;
  };

  React.useImperativeHandle(ref, () => ({ getModel }));

  const { title, subtitle, isPrivate, type_id, error } = state;
  const TypeOptions = [
    { label: "Text", value: 1 },
    { label: "Verweis auf eine Seite", value: 2 },
  ];
  let typeMarkup = (
    <HtmlContentForm ref={bodyFormRef} model={model} disabled={disabled} />
  );
  if (`${type_id}` !== "1") {
    typeMarkup = (
      <LinkForm ref={bodyFormRef} model={model} disabled={disabled} />
    );
  }
  return (
    <div className={className}>
      <div className={`form-group-item ${error.title && "error-group"}`}>
        <Label htmlFor="title">{`Titel*`}</Label>
        <InputText
          id="title"
          className="w3-block w3-border"
          value={title}
          onChange={(event) => {
            const value = event.target.value;
            setState((prev) => ({ ...prev, title: value }));
          }}
          disabled={disabled}
        />
      </div>
      <div className={`form-group-item ${error.subtitle && "error-group"}`}>
        <Label htmlFor="subtitle">{`Untertitel`}</Label>
        <InputText
          id="subtitle"
          className="w3-block w3-border"
          value={subtitle || ""}
          onChange={(event) => {
            const value = event.target.value;
            setState((prev) => ({ ...prev, subtitle: value }));
          }}
          disabled={disabled}
        />
      </div>
      <div className="neg-margin-lr w3-row">
        <div className="w3-col s6 pad-lr pad-top form-group-item">
          <Label>{`Sichtbarkeit*`}</Label>
          <div className="w3-row">
            <div className="w3-col s6">
              <div className="p-col-12">
                <RadioButton
                  inputId={`private`}
                  name="isPrivate"
                  value="1"
                  checked={`${isPrivate}` !== "0"}
                  onChange={(event) => {
                    const value = event.value;
                    setState((prev) => ({ ...prev, isPrivate: value }));
                  }}
                  disabled={disabled}
                />
                <label
                  htmlFor={`private`}
                  className="p-radiobutton-label pad-lft"
                >{`Nur sichtbar für angemeldete Benutzer`}</label>
              </div>
            </div>
            <div className="w3-col s6">
              <div className="p-col-12">
                <RadioButton
                  inputId={`public`}
                  name="isPrivate"
                  value="0"
                  checked={`${isPrivate}` === "0"}
                  onChange={(event) => {
                    const value = event.value;
                    setState((prev) => ({ ...prev, isPrivate: value }));
                  }}
                  disabled={disabled}
                />
                <label
                  htmlFor={`public`}
                  className="p-radiobutton-label pad-lft"
                >{`Für alle sichtbar`}</label>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`w3-col s6 pad-lr pad-top form-group-item ${
            error.type_id ? " error-group" : ""
          }`}
        >
          <Label htmlFor="type_id">{`Art von Beitragsinhalt*`}</Label>
          <Dropdown
            id="type_id"
            className="w3-block w3-border"
            value={type_id}
            options={TypeOptions}
            onChange={(event) => {
              const value = event.value;
              setState((prev) => ({ ...prev, type_id: value }));
            }}
            showClear
            disabled={disabled}
          />
        </div>
      </div>
      <div className="pad-top">
        <Label htmlFor="body*">{`Inhalt`}</Label>
        {typeMarkup}
      </div>
    </div>
  );
});

export default NewsArticleForm;
